import React from "react";
import { Row, Col, Spinner, Nav, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPencil } from "@fortawesome/free-solid-svg-icons";
import "./HiringManagerProfile.scss";
import TextEditor from "../../Common/Editor";
import useHiringManagerProfile from "./useHiringManagerProfile";
import MainLayout from "../../Common/MainLayout";
import { TimezoneSearchInput } from "../../../_uiComponents/Search/TimezoneSearchInput";

export default (props) => {
  const {
    loading,
    companyDetails,
    userData,
    formInputsError,
    error,
    getHtmlData,
    onSaveClick,
    onImageUpload,
    onCreateJobsClick,
    onInpuBlur,
    onProfileInputBlur,
    onProfileImageUpload,
    onTimeZoneChange,
  } = useHiringManagerProfile(props);

  const isTimeZoneDisabled =
    userData?.timezone === "UTC" || userData?.timezone === "Etc/UTC";

  return (
    <MainLayout pageName="Profile">
      <div className="container">
        <div className="hiring-manager-profile-wrapper">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="text-dark">{companyDetails.name}</h2>
            <div className="btns-wrapper text-right">
              <button
                className="btn btn-primary mr-3 mb-3"
                onClick={() => onCreateJobsClick()}
              >
                Create a new job
              </button>
            </div>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Tab.Container className="mb-3 pb-4" defaultActiveKey="Profile">
              <Nav className="nav-tabs bg-transparent">
                <Nav.Item>
                  <Nav.Link eventKey="Profile" className="bg-transparent">
                    <span className="font-weight-semi">Profile</span>
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="Company Profile">
                    <span className="font-weight-semi">Company Profile </span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="Profile" title="Profile">
                  <div className="job-detail-wrapper mt-4  px-0">
                    <Row>
                      <div className="col-md-8 mb-4">
                        <div className="py-3 px-4 bg-white form-group mb-0 border border-radius-10">
                          <h2 className="font-weight-medium mb-4">
                            Personal Information
                          </h2>
                          <Row>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Full
                                  name
                                </p>
                                <input
                                  className="form-control  mw-100"
                                  type="text"
                                  placeholder="Enter Company name"
                                  defaultValue={userData.full_name}
                                  disabled
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Email
                                </p>
                                <input
                                  className="form-control  mw-100"
                                  type="text"
                                  placeholder="Enter Company Phone Number"
                                  defaultValue={userData.email}
                                  disabled
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Company
                                  name
                                </p>
                                <input
                                  className="form-control  mw-100"
                                  type="text"
                                  placeholder="Enter Company name"
                                  defaultValue={
                                    userData?.user_meta_info &&
                                    userData.user_meta_info?.company_details &&
                                    userData.user_meta_info.company_details
                                      ?.name
                                  }
                                  disabled
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">Time Zone</p>
                                {/* <TimezoneSearchInput
                                  className="form-control"
                                  placeholder="Search Timezone..."
                                  onSearchSelect={(item) =>
                                    onTimeZoneChange({
                                      target: {
                                        value: item,
                                        name: "timezone",
                                      },
                                    })
                                  }
                                  isDisabled={!isTimeZoneDisabled}
                                  clearSearch={false}
                                  defaultTimezoneValue={
                                    userData?.timezone 
                                  }
                                /> */}
                                <div className="form-control">
                                  {userData?.timezone}
                                </div>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Phone
                                  Number
                                </p>
                                <input
                                  className="form-control mw-100"
                                  type="tel"
                                  placeholder="Enter Phone Number"
                                  name={"phone"}
                                  onBlur={(e) =>
                                    onProfileInputBlur(e.target.value, "phone")
                                  }
                                  defaultValue={
                                    userData?.user_meta_info &&
                                    userData.user_meta_info?.phone
                                  }
                                  disabled={
                                    userData?.user_meta_info &&
                                    userData.user_meta_info?.phone !== null
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">*</span> Image
                                </p>

                                <div className="custom-img-upload-input">
                                  <div className="file-input-wrapper">
                                    <label
                                      htmlFor="PhotoUpdate"
                                      className="file-input"
                                    >
                                      <img
                                        src={
                                          userData &&
                                          userData?.user_meta_info &&
                                          userData.user_meta_info?.profile_image
                                            ? userData &&
                                              userData?.user_meta_info &&
                                              userData.user_meta_info
                                                ?.profile_image
                                            : "/assets/images/user.png"
                                        }
                                        alt="mentor image"
                                        className="rounded-circle"
                                      />
                                      <input
                                        className="d-none"
                                        type="file"
                                        name="profile_image"
                                        accept="image/*"
                                        onChange={onProfileImageUpload}
                                        id="PhotoUpdate"
                                      />
                                      <span className="btn-remove-pic cursor-pointer  bg-grey-2 rounded-circle">
                                        <FontAwesomeIcon icon={faPencil} />
                                      </span>
                                    </label>
                                  </div>
                                  <p
                                    className="cursor-pointer text-grey-4"
                                    onClick={onImageUpload}
                                  >
                                    Replace file or Upload file from here
                                  </p>
                                </div>
                                <p className="fs-smallest text-grey-4">
                                  Maximum file size 3MB - acceptable file types
                                  .jpg, .jpeg, .gif, .png.
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Row>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="Company Profile" title="Company Profile">
                  <div className="job-detail-wrapper mt-4 container px-0">
                    <Row>
                      <div className="col-md-8 mb-4 ">
                        <div className="py-3 px-4 bg-white form-group mb-0 border border-radius-10">
                          <h2 className="font-weight-medium mb-4">
                            Company Information
                          </h2>
                          <Row>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Company
                                  name
                                </p>
                                <input
                                  className="form-control  mw-100"
                                  type="text"
                                  placeholder="Enter Company name"
                                  defaultValue={companyDetails?.name}
                                  disabled
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Company
                                  Industry
                                </p>
                                <span className="select">
                                  <select
                                    name=""
                                    id=""
                                    className="form-control"
                                    onChange={(e) =>
                                      onInpuBlur(e.target.value, "industry")
                                    }
                                    defaultValue={companyDetails?.industry}
                                  >
                                    <option value="IT">IT</option>
                                    <option value="Networking">
                                      Networking
                                    </option>
                                    <option value="Other">Other</option>
                                  </select>
                                </span>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Company
                                  Size
                                </p>
                                <span className="select">
                                  <select
                                    className="form-control  mw-100"
                                    onChange={(e) =>
                                      onInpuBlur(e.target.value, "size")
                                    }
                                    defaultValue={companyDetails?.size}
                                  >
                                    <option value="1-10">1-10</option>
                                    <option value="11-50">11-50</option>
                                    <option value="51-200">51-200</option>
                                  </select>
                                </span>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Website
                                </p>
                                <input
                                  className="form-control  mw-100"
                                  type="text"
                                  placeholder="Enter Company name"
                                  defaultValue={companyDetails?.url}
                                  disabled
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Phone
                                  number
                                </p>
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="Enter Company Phone Number"
                                  defaultValue={companyDetails?.phone_number}
                                  onBlur={(e) =>
                                    onInpuBlur(e.target.value, "phone_number")
                                  }
                                />
                              </div>
                              {error && error.length !== 0 ? (
                                <span className="text-danger">{error}</span>
                              ) : null}
                              {formInputsError ? (
                                <span className="text-danger">
                                  {formInputsError.msg}
                                </span>
                              ) : null}
                            </Col>
                            <Col md={6}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>
                                  LinkedIn url
                                </p>
                                <input
                                  className="form-control  mw-100"
                                  type="text"
                                  placeholder="Enter Company linkedIn Url"
                                  defaultValue={companyDetails?.linkedin_url}
                                  onBlur={(e) =>
                                    onInpuBlur(e.target.value, "linkedin_url")
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <div className="col-md-8 mb-4">
                        <div className="py-3 px-4 bg-white border border-radius-10 form-group mb-0">
                          <h2 className="font-weight-medium mb-4">
                            Company Identity
                          </h2>
                          <Row>
                            <Col lg={12}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Company
                                  Logo
                                </p>
                                <p className="text-grey-4">
                                  This will be displayed on job boards and
                                  welcome pages on video interviews and
                                  assessments.
                                </p>
                                <p className="font-weight-medium">Image</p>

                                <div className="custom-img-upload-input">
                                  <div className="file-input-wrapper">
                                    <label
                                      htmlFor="company-profile-pic"
                                      className="file-input"
                                    >
                                      <input
                                        type="file"
                                        className="d-none"
                                        id="company-profile-pic"
                                        accept="image/*"
                                        onChange={onImageUpload}
                                      />
                                      <img
                                        src={
                                          companyDetails?.logo
                                            ? companyDetails?.logo
                                            : "/assets/images/company-logo-placeholder.png"
                                        }
                                        alt="profile-pic"
                                        className="profile-pic rounded-circle  position-relative"
                                      />
                                      <span className="btn-remove-pic cursor-pointer  bg-grey-2 rounded-circle">
                                        <FontAwesomeIcon icon={faPencil} />
                                      </span>
                                    </label>
                                  </div>

                                  <p>
                                    <span className="text-primary">
                                      Upload a file
                                    </span>{" "}
                                    {/* or drag and drop here */}
                                  </p>
                                </div>
                                <p className="fs-smallest text-grey-4">
                                  Only .jpg, .jpeg, .gif or .png files allowed,
                                  no size limit.
                                </p>
                              </div>
                            </Col>

                            <Col lg={12}>
                              <div className="form-group mt-3">
                                <p className="font-weight-medium">
                                  <span className="text-danger"></span>Company
                                  Description
                                </p>
                                <p className="text-grey-4">
                                  This will be displayed on job boards and
                                  welcome pages on video interviews and
                                  assessments.
                                </p>
                                <TextEditor
                                  htmlData={
                                    companyDetails && companyDetails?.overview
                                  }
                                  getHtmlData={(data) =>
                                    getHtmlData(data, "overview")
                                  }
                                />
                              </div>
                            </Col>

                            <Col lg={12}>
                              <div className="border-top pt-3">
                                <button
                                  className="btn btn-primary"
                                  onClick={onSaveClick}
                                >
                                  Save Changes
                                </button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Row>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          )}
        </div>
      </div>
    </MainLayout>
  );
};
